define([
	"dojo/_base/declare",
	"csi/xml",
	"./NewThemeFromProductOnTable"
], function(declare,xml,NewThemeFromProductOnTable) {

	return declare(NewThemeFromProductOnTable, {
		_canSelectProduct: function(/*Context*/ctx, /*FormData*/fd) {
			var style = ctx.getNode();
			return xml.nodeHasRight(style, xml.RIGHT_WRITE);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for Original Season on Theme create form
			this.inherited(arguments);

			if (view.getFixedValue) {
				view.addDefaultValue("ThemeSeason", this.getNode().ParentSeason);
				view.addDefaultValue("ThemeSeasons", [this.getNode().ParentSeason]);
			}
		}
	});
});